import { Box } from "@mui/material";
import React, { useContext, useState } from "react";
import SidebarContext from "../../../context/SidebarContext";
import PageHeader from "../../../components/PageHeader";
import TopUpHistoryTable from "./TopUpHistory";
import AddFundDrawer from "./AddFundDrawer";

function Campiagn() {
  const { open } = useContext(SidebarContext);
  const [addFundDrawer, setAddFundDrawer] = useState(false);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <PageHeader pageTitle={"Customers"} />
      </Box>
      <TopUpHistoryTable
        setAddFundDrawer={setAddFundDrawer}
        addFundDrawer={addFundDrawer}
      />
      {addFundDrawer && (
        <AddFundDrawer
          setAddFundDrawer={setAddFundDrawer}
          addFundDrawer={addFundDrawer}
        />
      )}
    </Box>
  );
}

export default Campiagn;
